import React from "react";
function TagFolder() {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v3-conversation--tag-folder ">
          <div className="app-v3-conversation--tag-folder--title">
            Thư mục nhãn
          </div>
          <div className="app-v3-conversation--tag-folder--action">
            <div className="app-settings-tab-content--header app-settings-tab-content--header-sticky">
              <div className="app-settings-tab-content--flex">
                <div className="app-settings-tab-content--header-actions">
                  <div className="app-stack app-stack--align-center">
                    <div className="app-stack--item">
                      <button
                        type="button"
                        className="app-btn app-btn-primary app-settings-tab-content--header-actions-btn app-btn-action"
                      >
                        <svg
                          width="16"
                          height="16"
                          fill="none"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill="#fff"
                            fillRule="evenodd"
                            d="M1.333 8A6.67 6.67 0 018 1.333 6.67 6.67 0 0114.667 8 6.67 6.67 0 018 14.667 6.67 6.67 0 011.333 8zm7.334.667h2c.366 0 .666-.3.666-.667 0-.367-.3-.667-.666-.667h-2v-2c0-.366-.3-.666-.667-.666-.367 0-.667.3-.667.666v2h-2c-.366 0-.666.3-.666.667 0 .367.3.667.666.667h2v2c0 .366.3.666.667.666.367 0 .667-.3.667-.666v-2z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        <span>Thư mục mới</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="app-v2-layout-content app-v3-conversation--tag-folder--container">
          <div className="app-settings-tab-content">
            <div className="app-settings-tab-content--container">
              <div
                className="app-settings-tab-content--body"
                id="app-settings-tab--folder"
              >
                <div className="app-settings-tab-content--section">
                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Chatbot
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--tooltip-guide">
                            <svg
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm-.333 12.667a1 1 0 110-2.001 1 1 0 010 2zm2.874-5.916c-.206.33-.598.701-1.175 1.113-.934.69-.909.844-.909 1.47H10.82c0-.49-.01-.865.254-1.321.168-.293.478-.604.927-.934.54-.385 1.063-.756 1.063-1.403 0-.606-.518-.822-1.124-.822-.618 0-1.323.202-2.114.606L9.15 8.107c1.438-.806 3.707-1.171 4.948-.161.91.742.916 2.047.442 2.805z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Facebook
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--tooltip-guide">
                            <svg
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm-.333 12.667a1 1 0 110-2.001 1 1 0 010 2zm2.874-5.916c-.206.33-.598.701-1.175 1.113-.934.69-.909.844-.909 1.47H10.82c0-.49-.01-.865.254-1.321.168-.293.478-.604.927-.934.54-.385 1.063-.756 1.063-1.403 0-.606-.518-.822-1.124-.822-.618 0-1.323.202-2.114.606L9.15 8.107c1.438-.806 3.707-1.171 4.948-.161.91.742.916 2.047.442 2.805z"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Chưa xác định
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-folder--dropdown-container">
                            <div className="app-settings-tab-content--group-btn">
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <g>
                                  <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z"></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Tư vấn - Bán hàng (11)
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-folder--dropdown-container">
                            <div className="app-settings-tab-content--group-btn">
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <g>
                                  <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z"></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Vận hành - Giao hàng (2)
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-folder--dropdown-container">
                            <div className="app-settings-tab-content--group-btn">
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <g>
                                  <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z"></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="app-settings-tab-content--group">
                    <div className="app-settings-tab-content--group-header">
                      <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon app-settings-tab-content--group-icon-folder">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                          <div className="app-settings-tab-content--group-title">
                            Nhóm khách hàng (6)
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-tab-content--group-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <g>
                                <path d="M14.4599 8.28996L11.9999 5.82996L9.52989 8.28996C9.13989 8.67996 8.50989 8.67996 8.11989 8.28996C7.72989 7.89996 7.72989 7.26996 8.11989 6.87996L11.2899 3.69996C11.4767 3.5127 11.7304 3.40747 11.9949 3.40747C12.2594 3.40747 12.5131 3.5127 12.6999 3.69996L15.8699 6.87996C16.2599 7.26996 16.2599 7.89996 15.8699 8.28996C15.4799 8.67996 14.8499 8.67996 14.4599 8.28996ZM9.53989 15.71L11.9999 18.17L14.4699 15.72C14.6567 15.5327 14.9104 15.4275 15.1749 15.4275C15.4394 15.4275 15.6931 15.5327 15.8799 15.72C16.2699 16.11 16.2699 16.74 15.8799 17.13L12.7099 20.3C12.3199 20.69 11.6899 20.69 11.2999 20.3L8.12989 17.12C7.73989 16.73 7.73989 16.1 8.12989 15.71C8.31672 15.5227 8.57037 15.4175 8.83489 15.4175C9.09941 15.4175 9.35306 15.5227 9.53989 15.71Z"></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="app-stack--item">
                          <div className="app-settings-folder--dropdown-container">
                            <div className="app-settings-tab-content--group-btn">
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <g>
                                  <path d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z"></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TagFolder;
